import React from "react";
import PropTypes from "prop-types";
import { Typography, Badge } from "antd";
import FormHeaderWrapper from "./FormHeader.style";
const { Title } = Typography;

const FormHeader = (props) => {
  const { title, status, comp } = props;
  return (
    <FormHeaderWrapper>
      <div style={{ display: "flex", alignItems: "center" }}>
        {status ? <Badge status={status} /> : null}

        <Title level={5} style={{ margin: 0 }}>
          {title}
        </Title>
      </div>
      {comp && comp}
    </FormHeaderWrapper>
  );
};

FormHeader.propTypes = {
  title: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default FormHeader;
